'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _deepEqual = require('deep-equal');

var _deepEqual2 = _interopRequireDefault(_deepEqual);

var _addLabels = require('./add-labels');

var _addLabels2 = _interopRequireDefault(_addLabels);

require('../flot/jquery.flot.min');

require('../flot/jquery.flot.tooltip.min');

require('../flot/jquery.flot.pie.min');

require('../flot-override/jquery.flot.resize');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ReactFlot = function (_Component) {
  _inherits(ReactFlot, _Component);

  function ReactFlot() {
    _classCallCheck(this, ReactFlot);

    return _possibleConstructorReturn(this, (ReactFlot.__proto__ || Object.getPrototypeOf(ReactFlot)).apply(this, arguments));
  }

  _createClass(ReactFlot, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.draw();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (!(0, _deepEqual2.default)(nextProps.data, this.props.data) || !(0, _deepEqual2.default)(nextProps.options, this.props.options)) {
        this.draw(null, nextProps);
      }
    }
  }, {
    key: 'draw',
    value: function draw(event, nextProps) {
      var data = nextProps && nextProps.data || this.props.data;
      var options = nextProps && nextProps.options || this.props.options;
      var chart = _jquery2.default.plot((0, _jquery2.default)('#' + this.props.id), data, options);
      (0, _addLabels2.default)(chart, options);
    }
  }, {
    key: 'render',
    value: function render() {
      var style = {
        height: this.props.height || '400px',
        width: this.props.width || '100%'
      };

      return _react2.default.createElement('div', { id: this.props.id, style: style });
    }
  }]);

  return ReactFlot;
}(_react.Component);

ReactFlot.propTypes = {
  id: _propTypes2.default.string.isRequired,
  data: _propTypes2.default.array.isRequired, // eslint-disable-line
  options: _propTypes2.default.object.isRequired, //eslint-disable-line
  height: _propTypes2.default.string,
  width: _propTypes2.default.string
};
exports.default = ReactFlot;